import { render, staticRenderFns } from "./DSPCampaignsTable.vue?vue&type=template&id=cb4cda56&scoped=true&"
import script from "./DSPCampaignsTable.vue?vue&type=script&lang=js&"
export * from "./DSPCampaignsTable.vue?vue&type=script&lang=js&"
import style0 from "./DSPCampaignsTable.vue?vue&type=style&index=0&id=cb4cda56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4cda56",
  null
  
)

export default component.exports